import React, { useState, useEffect } from "react";

const CommitteeForm = () => {
  const [committeeData, setCommitteeData] = useState({});

  useEffect(() => {
    fetch("https://mosque-backend-yfae.vercel.app/comittee")
      .then((response) => response.json())
      .then((data) => setCommitteeData(data))
      .catch((error) => console.error("Error fetching committee data:", error));
  }, []);
  console.log(committeeData);
  const handleInputChange = (category, index, field, value) => {
    const updatedCategory = [...committeeData[category]];
    updatedCategory[index][field] = value;
    setCommitteeData({ ...committeeData, [category]: updatedCategory });
  };

  const addMember = (category) => {
    setCommitteeData({
      ...committeeData,
      [category]: [
        ...(committeeData[category] || []),
        { name: "", role: category, image: "" },
      ],
    });
  };

  const removeMember = (category, index) => {
    const updatedCategory = committeeData[category].filter(
      (_, i) => i !== index
    );
    setCommitteeData({ ...committeeData, [category]: updatedCategory });
  };

  const handleImageUpload = async (category, index, file) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch(
        "https://api.imgbb.com/1/upload?key=486efa604b729a5151b5e18abca412d5",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      if (data.success) {
        handleInputChange(category, index, "image", data.data.url);
      }
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://mosque-backend-yfae.vercel.app/addComitteeMember",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(committeeData),
        }
      );
      const result = await response.json();
      console.log("Server response:", result);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen flex flex-col items-center">
      <h2 className="text-2xl font-bold mb-4 text-center">
        Committee Management
      </h2>
      <form
        className="w-full max-w-4xl bg-white p-6 rounded shadow-md"
        onSubmit={handleSubmit}
      >
        {[
          "Founder",
          "Motowali Panel",
          "Active Committee",
          "Members",
          "Panel 1",
          "Panel 2",
        ].map((category) => (
          <div key={category} className="mb-6">
            <h3 className="text-lg font-semibold mb-2 text-center">
              {category}
            </h3>
            {(committeeData[category] || []).map((member, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row gap-2 mb-2 items-center w-full"
              >
                <input
                  type="text"
                  placeholder="Name"
                  className="border p-2 flex-1 w-full md:w-auto"
                  value={member.name}
                  onChange={(e) =>
                    handleInputChange(category, index, "name", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Role"
                  className="border p-2 flex-1 w-full md:w-auto"
                  value={member.role}
                  readOnly
                />
                <input
                  type="file"
                  className="border p-2 flex-1 w-full md:w-auto"
                  onChange={(e) =>
                    handleImageUpload(category, index, e.target.files[0])
                  }
                />
                {member.image && (
                  <img
                    src={member.image}
                    alt="Uploaded"
                    className="w-16 h-16 object-cover rounded"
                  />
                )}
                <button
                  type="button"
                  className="bg-red-500 text-white px-2 py-1 rounded"
                  onClick={() => removeMember(category, index)}
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              className="mt-2 bg-blue-500 text-white px-4 py-2 rounded w-full md:w-auto"
              onClick={() => addMember(category)}
            >
              + Add {category === "Founder" ? "Founder" : "Member"}
            </button>
          </div>
        ))}
        <button
          type="submit"
          className="mt-4 bg-green-500 text-white px-4 py-2 rounded w-full md:w-auto"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default CommitteeForm;
